import DatePicker from "@/components/DatePicker/index";

export function FilterDatePicker(props) {
	return (
		<DatePicker
			selectDate={props?.endDate}
			setSelectDate={props?.setEndDate}
			placeHolderText="Select date and time"
			disable={props?.disable}
			minDate={new Date(props?.startDate)}
			minTime={
				props?.startDate && props?.endDate
					? props?.startDate.getDate() === props?.endDate.getDate()
						? new Date(props?.startDate)
						: new Date().setHours(0, 0, 0)
					: new Date(0, 0, 0)
			}
			maxTime={new Date().setHours(23, 59, 59)}
		/>
	);
}
